import React from 'react';
import PageLayout from '../../components/PageLayout';
import PeopleToolbar from './PeopleToolbar';
import PeopleList from './PeopleList';
import PeopleDetails from './PeopleDetails';
import PeoplePlaceholder from './PeoplePlaceholder';
import { useSelector, useDispatch } from 'react-redux';
import { StoreState } from '../../store';
import { getPeople } from '../../store/people/peopleActions';
import { PeopleActionTypes } from '../../store/people/peopleTypes';

export default function People() {
  const dispatch = useDispatch();
  const { isEditing, selectedIndex } = useSelector((state: StoreState) => ({
    isEditing: state.peopleState.isEditing,
    selectedIndex: state.peopleState.selectedIndex,
  }));

  const onMountPage = () => dispatch(getPeople());
  const onUnmountPage = () => dispatch({ type: PeopleActionTypes.CLEAR });

  return (
    <PageLayout
      toolbar={<PeopleToolbar />}
      list={<PeopleList />}
      details={<PeopleDetails key={String(selectedIndex)} />}
      detailsPlaceholder={<PeoplePlaceholder />}
      hideDetails={!isEditing}
      onMountPage={onMountPage}
      onUnmountPage={onUnmountPage}
    />
  );
}
